// Sticky Add to Cart Button logic for single product page
// Moves the main add to cart button into a sticky bar when it is not visible

export function initStickyAddToCart({ addToCartButton, cartForm }) {
    if (!addToCartButton || !cartForm) return;
    const stickyContainer = document.getElementById('sticky-add-to-cart-container');
    if (!stickyContainer) return;

    let originalButtonParent = addToCartButton.parentNode;
    let originalButtonNextSibling = addToCartButton.nextSibling;

    const observer = new window.IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                // Button is visible in viewport, move it back to form
                if (addToCartButton.parentNode !== originalButtonParent) {
                    originalButtonParent.insertBefore(addToCartButton, originalButtonNextSibling);
                    stickyContainer.classList.add('translate-y-full', 'pointer-events-none');
                    stickyContainer.classList.remove('translate-y-0');
                }
            } else {
                // Button is not visible, move it to sticky container
                if (addToCartButton.parentNode !== stickyContainer) {
                    stickyContainer.appendChild(addToCartButton);
                    stickyContainer.classList.remove('translate-y-full', 'pointer-events-none');
                    stickyContainer.classList.add('translate-y-0');
                }
            }
        },
        { threshold: 0.01 }
    );
    observer.observe(cartForm);
}
